<template>
	<card class="is-card-table has-pagination has-table-borderless has-bottom-left-hidden" title="お知らせ一覧" icon="format-list-bulleted">
		<b-button slot="button" type="is-success" @click="onNewButtonClick">新規作成</b-button>
		<information-table :data="data" :totalNum="totalNum" :isLoading="isLoading" :checkable="false" @delete-button-click="onDeleteButtonClick"/>
	</card>
</template>

<script>
import Card from "@/components/Card";
import InformationTable from "@/components/InformationTable";
import qs from 'qs';

export default {
	name: 'information',
	components: {
		Card,
		InformationTable,
	},
	data() {
		return {
			data: [],
			isLoading: false,
			totalNum: 0,
		}
	},
	mounted() {
		this.init();
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['お知らせ管理']
		});
	},
	methods: {
		onNewButtonClick: function() {
			this.$router.push({ name: 'information-new' });
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			this.isLoading = true;

			let ep = 'informations'
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				if (!res.data.list) {
					this.data = [];
				} else {
					this.data = res.data.list;
				}
				this.totalNum = this.data.length;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onDeleteButtonClick: async function(id) {
			if (!window.confirm(this.$consts.MSG_CONFIRM_DELETE)) {
				return false;
			}

			let loading = this.$loading.open();
			let ep = 'informations/delete';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, { "id": id }, true);
				this.$utils.log(res);
				this.data.some(function(v, i){
					if (v.id === id) this.data.splice(i, 1);
				}, this);
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loading.close();
			}
		}
	},
}
</script>

<style scoped>
</style>
